import { Body } from "./Body";
import { Container } from "./Container";
import { Header } from "./Header";

export const Schedule = {
  Body,
  Container,
  Header,
};
